module.exports = __webpack_public_path__ + "static/6-3e29cd74a98695a3cb8a384b12ef5cf3.jpeg";